import {
    createSelector,
} from '@reduxjs/toolkit';

import { selectUserSelections } from './baseBetslipSelectors';

export const selectAllFreeBets = state => state.betslip.freeBets.freebets;

export const selectFreeBets = createSelector(
    [
        selectAllFreeBets,
        (_state, betslipId) => betslipId,
    ],
    (freebetsByBetslip, betslipId) => {
        const freebets = freebetsByBetslip[betslipId];

        if (!freebets) {

            return null;
        }

        const sortedFreebets = [...freebets];
        sortedFreebets.sort((a, b) => new Date(a.expires_at) - new Date(b.expires_at));

        return sortedFreebets;
    }
);

export const selectSelectedFreebets = createSelector(
    [selectUserSelections],
    (userSelections) => userSelections
        .filter(selection => selection.free_bet_id)
        .map(selection => ({
            id: selection.id,
            freebet: selection.free_bet_id,
        }))
);

export const selectFreebetById = (state, betslipId, freebetId) => {
    const freebets = selectAllFreeBets(state);
    if (!betslipId || !freebets || !freebets[betslipId]) {
        return null;
    }

    return freebets[betslipId].find(freebet => freebet.id === freebetId);
};

export const selectAvailableFreebets = createSelector(
    [
        selectFreeBets,
        selectSelectedFreebets,
        selectFreebetById,
    ],
    (freebets, selectedFreebets, currentFreebet) => {
        if (!freebets) {
            return [];
        }

        return freebets.filter(freebet => {
            const isSelected = selectedFreebets.find(selectedFreebet => selectedFreebet.freebet === freebet.id);
            const isCurrent = freebet.id === currentFreebet?.id;

            return !isSelected || isCurrent;
        });
    }
);
